/**********************************************************************
// @@@ START COPYRIGHT @@@
//        AVI SOLAR ENERGY CONFIDENTIAL: NEED TO KNOW ONLY
//        Copyright 2018 - 2019
//        Avi Solar Energy Pvt Ltd.
//        Protected as an unpublished work.
//  The computer program listings, specifications and documentation
//  herein are the property of Avi Solar Energy Pvt Ltd., or a third party supplier
//  and shall not be reproduced, copied, disclosed, or used in whole or in part for
//  any reason without the prior express written permission of Avi Solar Energy Pvt Ltd.
// @@@ END COPYRIGHT @@@
// +++ Code modified on 2019/02/25
**********************************************************************/
<template>
  <v-layout wrap>
    <v-flex
      :class="flexSize"
      v-for="(item, key) in boxDataSet"
      v-bind:key="key"
    >
      <Card class="ws-data-card pb-1">
        <v-layout row wrap pa-2>
          <v-flex xs12 class="fs-16 ts activeText--text" mb-1
            >{{ $t(item.key) }} ({{ unit(item.key) }})
          </v-flex>
          <v-flex sm12 pa-0>
            <v-layout row wrap justify-space-around text-xs-center>
              <v-flex shrink>
                <div class="op-1 mb-1">{{ $t("MIN") }}</div>
                <div
                  :class="
                    item.min == 'N/A' || item.min == 'No Data'
                      ? 'fs-16 error--text'
                      : 'fs-16 number--text'
                  "
                >
                  {{ item.min | round }}
                </div>
              </v-flex>
              <v-flex shrink>
                <div class="op-1 mb-1">{{ $t("AVG") }}</div>
                <div
                  :class="
                    item.average == 'N/A' || item.average == 'No Data'
                      ? 'fs-16 error--text'
                      : 'fs-16 number--text'
                  "
                >
                  {{ item.average | round }}
                </div>
              </v-flex>
              <v-flex shrink>
                <div class="op-1 mb-1">{{ $t("MAX") }}</div>
                <div
                  :class="
                    item.max == 'N/A' || item.max == 'No Data'
                      ? 'fs-16 error--text'
                      : 'fs-16 number--text'
                  "
                >
                  {{ item.max | round }}
                </div>
              </v-flex>
              <v-flex shrink>
                <div class="op-1 mb-1">{{ $t("LAST PACKET") }}</div>
                <div
                  :class="
                    item.live == 'N/A' || item.live == 'No Data'
                      ? 'fs-16 error--text'
                      : 'fs-16 number--text'
                  "
                >
                  {{ item.live | round }}
                </div>
              </v-flex>
              <v-flex shrink v-if="item.cumulative !== undefined">
                <div class="op-1 mb-1">{{ $t("CUMULATIVE") }}</div>
                <div
                  :class="
                    item.cumulative == 'N/A' || item.cumulative == 'No Data'
                      ? 'fs-16 error--text'
                      : 'fs-16 number--text'
                  "
                >
                  {{ item.cumulative | round }}
                </div>
              </v-flex>
            </v-layout>
          </v-flex>
        </v-layout>
      </Card>
    </v-flex>
  </v-layout>
</template>

<script>
import { mapGetters } from "vuex";
import { mixin } from "@/util/mixin/index";
import Card from "@/components/common/Cards.vue";
export default {
  components: {
    Card,
  },
  props: ["title", "max", "min", "avg", "live", "cumulative", "boxDataSet"],
  mixins: [mixin],
  data() {
    return {
      insolation: 0,
    };
  },
  computed: {
    ...mapGetters(["getGeneralState"]),
    flexSize() {
      const length = Object.keys(this.boxDataSet).length;
      if (length === 0) {
        return "xs12";
      }
      if (length >= 4) {
        return "xs3";
      }
      return "xs" + 12 / length;
    },
    getImage: function () {
      switch (this.title) {
        case "Irradiance Horizontal":
        case "Irradiance Vertical":
          return require(this.getGeneralState("theme_dark")
            ? "../../assets/sun (2).png"
            : "../../assets/sun-dark1.png");

        case "Module Temperature":
        case "Ambient Temperature":
          return require(this.getGeneralState("theme_dark")
            ? "../../assets/thermometer-light.png"
            : "../../assets/thermometer-dark.png");

        case "Wind Speed":
          return require(this.getGeneralState("theme_dark")
            ? "../../assets/wind.png"
            : "../../assets/wind-dark.png");

        case "Rain Gauge":
          return require(this.getGeneralState("theme_dark")
            ? "../../assets/wind.png"
            : "../../assets/wind-dark.png");

        case "Humidity":
          return require(this.getGeneralState("theme_dark")
            ? "../../assets/humidity-light.png"
            : "../../assets/humidity-dark.png");

        case "Pressure":
          return require(this.getGeneralState("theme_dark")
            ? "../../assets/manometer-light.png"
            : "../../assets/manometer-dark.png");
      }
    },
  },
  methods: {
    unit: function (title) {
      switch (title) {
        case "GHI":
        case "PoA":
        case "GTI":
        case "Radiation":
        case "Irradiance Horizontal":
        case "Irradiance Vertical":
          return "w/m²";
        case "Module Temperature":
        case "Ambient Temperature":
          return "°C";
        case "Wind Direction":
          return "°";
        case "Wind Speed":
          return "m/s";
        case "Rain Gauge":
          return "mm";
        case "Humidity":
          return "%";
        case "Pressure":
          return "hPa";
      }
    },
  },
};
</script>

<style scoped>
.icon {
  padding: 5px;
}
.main-container {
  border-radius: 0.75rem;
}
.ws-data-card {
  margin-top: 4px;
  border-radius: 4px;
}
@media (min-width: 320px) and (max-width: 960px) {
  .main-container {
    margin: 4px auto 10px auto !important;
  }
}
</style>
